import { createContext, useContext, useState, useCallback } from 'react';
import translations from '@/lib/i18n';
import api from '@/lib/api';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(localStorage.getItem('lang') || 'en');

  const toggleLanguage = () => {
    const newLang = language === 'en' ? 'gu' : 'en';
    setLanguage(newLang);
    localStorage.setItem('lang', newLang);
  };

  const t = useCallback((key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  }, [language]);

  const transliterate = useCallback(async (text) => {
    if (!text) return text;
    try {
      const { data } = await api.get('/transliterate', { params: { text } });
      return data.result;
    } catch {
      return text;
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t, transliterate, isGujarati: language === 'gu' }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
